export class SectorModel {
  public static IRI = '/api/sectors';
  public name: string;
  public id: number;
}
